<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="section">
<h1></h1>
<div class="figure">
<img alt="" class="img-centre" src="media/file0.jpg" style="width:3.61875in;height:2.03627in"/>
<p class="caption">C:\Users\V\Desktop\new pictures\2.jpg</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?7e76a3f0